import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import type { ReactNode } from 'react';

export function WandIcon(props: SvgIconProps): ReactNode {
  return (
    <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M5 19l9-9"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M14 5.5l1 1M17 3l.6 1.8L19.5 5.4 18 6.8l.4 1.9L17 7.6l-1.7 1 .5-1.9-1.4-1.3 1.9-.2z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M13 9l2 2"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        fill="none"
      />
    </SvgIcon>
  );
}
